import "../../styles/BirthdayParty/BirthdayPartyCommons.css"
import "../../styles/Birthday.css"

import { useEffect, useState, useCallback, useRef } from "react"

function BirthdayJoin() {
    const [isConnected, setConnected] = useState(false)
    const [user, setUser] = useState(null)
    const [formData, setFormData] = useState({
        name: "",
        photoBlob: null,
        photoUrl: ""
    })

    const [message, setMessage] = useState("")
    const [photo, setPhoto] = useState({
        photoBlob: null,
        photoUrl: ""
    })

    const [isCameraOpen, setCameraOpen] = useState(false)
    const [cameraError, setCameraError] = useState("")
    const [cameraAttempt, setCameraAttempt] = useState(0)
    const [cameraFacingMode, setCameraFacingMode] = useState("user")

    const [isPhotobooth, setPhotobooth] = useState(false)
    const [photoBoothData, setPhotoBoothData] = useState({
        photo1: {
            photoBlob: null,
            photoUrl: ""
        }, 
        photo2: {
            photoBlob: null,
            photoUrl: ""
        },
        photo3: {
            photoBlob: null,
            photoUrl: ""
        },
        photo4: {
            photoBlob: null,
            photoUrl: ""
        }
    })
    const [photoboothMontage, setPhotoboothMontage] = useState({
        photoBlob: null,
        photoUrl: ""
    })
    const [photoboothSended, setPhotoboothSended] = useState(false)

    const [photoboothTimer, setPhotoboothTimer] = useState(4)
    const [photoboothStep, setPhotoboothStep] = useState(0)

    const videoRef = useRef(null)
    const canvasRef = useRef(null)
    const streamRef = useRef(null)

    const checkUser = useCallback(() => {
        if(!localStorage.getItem("birthdayToken")) {
            setConnected(false)
        } else {
            setConnected(true)
        }
    }, [])

    useEffect(() => {
        checkUser()
    }, [checkUser])

    const stopCamera = useCallback(() => {
        if(streamRef.current) {
            streamRef.current
                .getTracks()
                .forEach((track) => track.stop())

            streamRef.current = null
        }

        if(videoRef.current) {
            videoRef.current.srcObject = null
        }

        setCameraOpen(false)
    }, [])

    const stopCameraStream = () => {
        if(streamRef.current) {
            streamRef.current.getTracks().forEach((track) => {
                track.stop()
            })

            streamRef.current = null
        }

        if(videoRef.current) {
            videoRef.current.srcObject = null
        }
    }

    const openCamera = async (facingMode = "user") => {
        setCameraError("")

        if(!navigator.mediaDevices?.getUserMedia) {
            setCameraError("La caméra n'est pas disponible sur cet appareil.")
            setCameraAttempt(cameraAttempt + 1)
            return
        }

        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: {
                        ideal: facingMode
                    }
                },
                audio: false
            })

            streamRef.current = stream
            setCameraFacingMode(facingMode)
            setCameraOpen(true)
        } catch (error) {
            console.error(`Error cam : `, error);
            setCameraAttempt(cameraAttempt + 1)

            if(error.name === "NotAllowedError") {
                setCameraError("L'accès à la caméra a été refusé")
                return
            }

            if(error.name === "NotFoundError") {
                setCameraError("Aucune caméra n'a été trouvé")
                return
            }

            setCameraError("Impossible d'ouvrir la caméra.")
        }
    }

    const takePhoto = (photoType = "none") => {
        const video = videoRef.current
        const canvas = canvasRef.current

        if(!video || !canvas) return

        if(!video.videoWidth || !video.videoHeight) {
            setCameraError("La caméra n'est pas encore prête.")
            return
        }

        canvas.width = video.videoWidth
        canvas.height = video.videoHeight

        const context = canvas.getContext("2d")
        if(!context) {
            setCameraError("Impossible de capturer la photo.")
            setCameraAttempt(cameraAttempt + 1)
            return
        }

        context.drawImage(
            video,
            0,
            0,
            canvas.width,
            canvas.height
        )

        canvas.toBlob((blob) => {
            if(!blob) {
                setCameraError("Impossible de générer la photo.")
                setCameraAttempt(cameraAttempt + 1)
                return
            }

            const photoUrl = URL.createObjectURL(blob)

            if(isConnected) {
                setPhoto({ photoBlob: blob, photoUrl: photoUrl })
            } else {
                console.log(photoType);
                
                if(photoType.includes("photobooth_")) {
                    const splitted = photoType.split("_")
                    const step = parseInt(splitted[1]) + 1

                    console.log(6);

                    setPhotoBoothData((prev) => {
                        const newData = {
                            ...prev,
                            [`photo${step}`]: {
                                photoBlob: blob,
                                photoUrl
                            }
                        }

                        return newData
                    })
                } else {
                    setFormData((previousFormData) => ({
                        ...previousFormData,
                        photoBlob: blob,
                        photoUrl
                    }))
                }
            }

            if(!photoType.includes("photobooth_")) {
                stopCamera()
            }

        }, "image/jpeg", 0.9)
    }

    const retakePhoto = async () => {
        if(isConnected) {
            if(photo.photoUrl) {
                URL.revokeObjectURL(photo.photoUrl)
            }

            setPhoto({ photoBlob: null, photoUrl: "" })
        } else {
            if(formData.photoUrl) {
                URL.revokeObjectURL(formData.photoUrl)
            }

            setFormData((previousFormData) => ({
                ...previousFormData,
                photoBlob: null,
                photoUrl: ""

            }))
        }

        await openCamera()
    }

    const switchCamera = async () => {
        const newFacingMode = cameraFacingMode === "user"
            ? "environment"
            : "user"
        try {
            await stopCamera()
            await openCamera(newFacingMode)
        } catch (error) {
            console.error("Impossible de retourner la caméra :", error)
            setCameraError("Impossible de retourner la caméra.")
        }

    }

    const startPhotobooth = () => {
        let currentStep = 0
        let currentTimer = 3

        setPhotoboothStep(currentStep)
        setPhotoboothTimer(currentTimer)

        const photoboothInterval = setInterval(() => {
            console.log(photoBoothData);

            currentTimer -= 1
            setPhotoboothTimer(currentTimer)

            if(currentTimer > 0) return;

            takePhoto(`photobooth_${currentStep}`)

            currentStep += 1
            setPhotoboothStep(currentStep)

            if(currentStep >= 4) {
                clearInterval(photoboothInterval)

                setTimeout(() => {
                    // TODO envoyer les photos
                    console.log("Photobooth terminé")
                }, 10_000)

                return
            }

            currentTimer = 3
            setPhotoboothTimer(currentTimer)
        }, 1000)
    }

    useEffect(() => {
        if(!isCameraOpen || !videoRef.current || !streamRef.current) {
            return
        }

        const video = videoRef.current
        video.srcObject = streamRef.current

        video.play().catch((error) => {
            console.error("Impossible de lire le flux vidéo :", error)
            setCameraError("Impossible d'afficher le flux de la caméra.")
        })
    }, [isCameraOpen])

    useEffect(() => {
        return () => {
            stopCamera()

            if(isConnected) {
                if(photo.photoUrl) {
                    URL.revokeObjectURL(photo.photoUrl)
                }
            } else {
                if(formData.photoUrl) {
                    URL.revokeObjectURL(formData.photoUrl)
                }
            }
        }
    }, [stopCamera, formData.photoUrl])

    const handleRegisterSubmit = async (event) => {
        event.preventDefault()

        if(!formData.name.trim()) {
            return
        }

        if(!formData.photoBlob && cameraAttempt < 3) {
            return;
        }

        console.log("Données à envoyer :", {
            name: formData.name,
            photoBlob: formData.photoBlob
        })

        try {
            const body = new FormData()

            body.append("name", formData.name.trim())

            if(formData.photoBlob) {
                body.append("photo", formData.photoBlob, `profile-photo.jpg`)
            } else {
                const responseLocal = await fetch("/meme-vieu.webp")
                const blob = await responseLocal.blob()

                body.append("photo", blob, "pas-de-photo-de-profil.webp")
            }

            const response = await fetch(`https://api.kenzo-simon.fr/birthday/party/register`, {
                method: "POST",
                body
            })

            const data = await response.json()

            if(!response.ok) {
                throw new Error(data.message || "Impossible de s'inscrire")
            }

            localStorage.setItem("birthdayToken", data.token)

            setUser(data.user)
            setConnected(true)
        } catch (error) {
            console.error("Erreur :", error);
        }
    }

    const handleSendPhoto = async (e) => {
        e.preventDefault()

        if(!photo.photoBlob) return;

        console.log("Données to send :", { photoBlob: photo.photoBlob });

        try {
            const body = new FormData()

            body.append("photo", photo.photoBlob, `photo`)

            const response = await fetch(`https://api.kenzo-simon.fr/birthday/party/send-photo`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("birthdayToken")}`
                },
                body
            })

            const data = await response.json()

            if(!response.ok) {
                throw new Error(data.message || "Une erreur s'est produite")
            }

            setPhoto({ photoBlob: null, photoUrl: "" })

        } catch (error) {
            console.error("Erreur :", error);
        }
    }

    const handleSendMessage = (e) => {
        e.preventDefault()

        if(!localStorage.getItem("birthdayToken")) {
            // TODO toast
            return
        }

        fetch(`https://api.kenzo-simon.fr/birthday/party/send-message`, {
            method: "POST",
            body: JSON.stringify({
                message: message
            }),
            headers: {
                "Content-Type": "application/json",
                "X-Content-Type-Options": "nosniff",
                "Content-Security-Policy": "default-src 'self'",
                "Authorization": `Bearer ${localStorage.getItem("birthdayToken")}`
            }
        }).then((res) => res.json()).then((data) => {
            if(data.success === false) {
                // TODO toast
            }

            setMessage("")
        }).catch((err) => {
            console.error(err);
            // TODO toast
        })
    }

    const handleChangeName = (e) => {
        e.preventDefault()

        const value = e.target.value
        if(value === "photobooth") {
            setPhotobooth(true)
            openCamera()
        } else {
            setFormData((prev) => ({
                ...prev,
                name: value
            }))
        }
    }

    // =================================================================
    // photobooth functions
    // =================================================================

    function loadImageFromUrl(url) {
        return new Promise((resolve, reject) => {
            const image = new Image()

            image.onload = () => resolve(image)
            image.onerror = () => reject(
                new Error(`Impossible de charger l'image : ${url}`)
            )

            image.src = url
        })
    }

    function drawImageCover(context, image, x, y, width, height) {
        const imageRatio = image.width / image.height
        const targetRatio = width / height

        let sourceX = 0
        let sourceY = 0
        let sourceWidth = image.width
        let sourceHeight = image.height

        if(imageRatio > targetRatio) {
            sourceWidth = image.height * targetRatio
            sourceX = (image.width - sourceWidth) / 2
        } else {
            sourceHeight = image.width / targetRatio
            sourceY = (image.height - sourceHeight) / 2
        }

        context.drawImage(
            image,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            x,
            y,
            width,
            height
        )
    }

    async function createPhotoboothMontage(photoBoothData) {
        const photos = [
            photoBoothData.photo1,
            photoBoothData.photo2,
            photoBoothData.photo3,
            photoBoothData.photo4
        ]

        const missingPhotoIndex = photos.findIndex((photo) => !photo?.photoUrl)

        if(missingPhotoIndex !== -1) {
            throw new Error(
                `La photo ${missingPhotoIndex + 1} est manquante`
            )
        }

        const images = await Promise.all(
            photos.map((photo) => loadImageFromUrl(photo.photoUrl))
        )

        const canvasSize = 1600
        const separatorSize = 24
        const outerBorderSize = 24

        const availableSize =
            canvasSize -
            outerBorderSize * 2 -
            separatorSize

        const photoSize = availableSize / 2

        const canvas = document.createElement("canvas")
        canvas.width = canvasSize
        canvas.height = canvasSize

        const context = canvas.getContext("2d")

        if(!context) {
            throw new Error("Impossible d'initialiser le canvas")
        }

        // Fond et séparations bleues
        context.fillStyle = "#5059BD"
        context.fillRect(0, 0, canvasSize, canvasSize)

        const positions = [
            {
                x: outerBorderSize,
                y: outerBorderSize
            },
            {
                x: outerBorderSize + photoSize + separatorSize,
                y: outerBorderSize
            },
            {
                x: outerBorderSize,
                y: outerBorderSize + photoSize + separatorSize
            },
            {
                x: outerBorderSize + photoSize + separatorSize,
                y: outerBorderSize + photoSize + separatorSize
            }
        ]

        images.forEach((image, index) => {
            const position = positions[index]

            drawImageCover(
                context,
                image,
                position.x,
                position.y,
                photoSize,
                photoSize
            )
        })

        const montageBlob = await new Promise((resolve, reject) => {
            canvas.toBlob(
                (blob) => {
                    if (!blob) {
                        reject(
                            new Error(
                                "Impossible de convertir le montage en image"
                            )
                        )
                        return
                    }

                    resolve(blob)
                },
                "image/jpeg",
                0.92
            )
        })

        const montageUrl = URL.createObjectURL(montageBlob)

        return {
            blob: montageBlob,
            url: montageUrl
        }
    }

    useEffect(() => {
        const hasAllPhotos =
            photoBoothData.photo1?.photoUrl &&
            photoBoothData.photo2?.photoUrl &&
            photoBoothData.photo3?.photoUrl &&
            photoBoothData.photo4?.photoUrl

        if(!hasAllPhotos) {
            return
        }

        let cancelled = false

        const generatePhotoboothMontage = async () => {
            try {
                const montage = await createPhotoboothMontage(photoBoothData)

                setPhotoboothMontage((prev) => {
                    if(prev.photoUrl) {
                        URL.revokeObjectURL(prev.photoUrl)
                    }

                    return {
                        photoBlob: montage.blob,
                        photoUrl: montage.url
                    }
                })

                console.log("Montage photobooth généré :", montage)
            } catch (error) {
                console.error(
                    "Erreur pendant la création du montage photobooth :",
                    error
                )
            }
        }

        generatePhotoboothMontage()

        return () => {
            cancelled = true
        }
    }, [photoBoothData])

    const sendPhotobooth = async () => {
        const hasAllPhotos =
            photoBoothData.photo1?.photoUrl &&
            photoBoothData.photo2?.photoUrl &&
            photoBoothData.photo3?.photoUrl &&
            photoBoothData.photo4?.photoUrl

        if(!hasAllPhotos || !photoboothMontage.photoUrl) {
            return
        }

        console.log("Données to send :", { photobooth: photoBoothData, montage: photoboothMontage });

        try {
            const body = new FormData()

            body.append("photo1", photoBoothData.photo1.photoBlob, "photo1")
            body.append("photo2", photoBoothData.photo2.photoBlob, "photo2")
            body.append("photo3", photoBoothData.photo3.photoBlob, "photo3")
            body.append("photo4", photoBoothData.photo4.photoBlob, "photo4")
            body.append("montage", photoboothMontage.photoBlob, "montage")

            const response = await fetch(`https://api.kenzo-simon.fr/birthday/party/photobooth`, {
                method: "POST",
                body
            })

            const data = await response.json()

            if(!response.ok) {
                throw new Error(data.message || "Une erreur s'est produite")
            }

            setTimeout(() => {
                setPhotoboothMontage({ photoBlob: null, photoUrl: "" })
                setPhotoBoothData({
                    photo1: {
                        photoBlob: null,
                        photoUrl: ""
                    }, 
                    photo2: {
                        photoBlob: null,
                        photoUrl: ""
                    },
                    photo3: {
                        photoBlob: null,
                        photoUrl: ""
                    },
                    photo4: {
                        photoBlob: null,
                        photoUrl: ""
                    }
                })

                setPhotoboothTimer(4)
            }, 5000)
        } catch (error) {
            console.error("Erreur :", error);
        }
    }

    useEffect(() => {
        if(photoboothMontage.photoUrl) {
            sendPhotobooth()
        }
    }, [photoboothMontage])

    return (
        <div className="body body-birthday_join body-birthday-special">
            <div className="join-content">
                {(!isConnected && !isPhotobooth) ? (
                    <>
                    <div className="birth-notconnected">
                        <form className="birth-join-form" onSubmit={handleRegisterSubmit}>
                            <div className="birth-inputbox">
                                <label className="birth-label">
                                    Nom ou pseudonyme *
                                </label>

                                <input 
                                    name="name"
                                    className="birth-input"
                                    placeholder="Nom ou pseudonyme"
                                    value={formData.name}
                                    onChange={handleChangeName}
                                    required
                                />
                            </div>

                            <div className="birth-inputbox">
                                <label className="birth-label">
                                    Photo de profil
                                </label>

                                {!isCameraOpen && !formData.photoUrl && (
                                    <>
                                    {cameraAttempt >= 3 ? (
                                        <>
                                        <button className="birth-button birth-special_button birth-button-open_camera" type="submit">
                                            Continuer sans photo
                                        </button>
                                        </>
                                    ) : (
                                        <>
                                        <button className="birth-button birth-special_button birth-button-open_camera" type="button" onClick={() => openCamera("user")}>
                                            Prendre une photo
                                        </button>
                                        </>
                                    )}
                                    </>
                                )}

                                {isCameraOpen && !formData.photoUrl && (
                                    <>
                                    <div className="birth-camera">
                                        <video 
                                            ref={videoRef}
                                            className="birth-camera-video"
                                            autoPlay
                                            playsInline
                                            muted
                                        />

                                        <canvas
                                            ref={canvasRef}
                                            style={{ display: "none" }}
                                        />

                                        <div className="birth-camera-actions">
                                            <button
                                                type="button"
                                                className="birth-button birth-special_button birth-camera-cancel"
                                                onClick={stopCamera}
                                            >
                                                Annuler
                                            </button>

                                            <button
                                                type="button"
                                                className="birth-button birth-special_button birth-camera-take"
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    takePhoto()
                                                }}
                                            >
                                                Prendre la photo
                                            </button>
                                        </div>
                                    </div>
                                    </>
                                )}

                                {formData.photoUrl && (
                                    <>
                                    <div className="birth-photo-preview">
                                        <img
                                            src={formData.photoUrl}
                                            alt="Photo prise"
                                            className="birth-photo-preview-image"
                                        />

                                        <div className="birth-photo-preview-actions">
                                            <button
                                                type="button"
                                                onClick={retakePhoto}
                                                className="birth-button birth-special_button birth-button-retake_photo"
                                            >
                                                Reprendre
                                            </button>
                                            
                                            <button
                                                type="submit"
                                                className="birth-button birth-special_button birth-button-validregister"
                                            >
                                                Valider
                                            </button>
                                        </div>
                                    </div>
                                    </>
                                )}
                            </div>
                        </form>
                    </div>
                    </>
                ) : (
                    <>
                    {!isPhotobooth ? (
                        <>
                        <div className="birth-connected">
                            <div className="connected-header">

                            </div>

                            <div className="connected-body">
                                <div className="connected-body-header">
                                    <h1 className="connected-title">Prends ta meilleure photo !</h1>
                                </div>

                                <div className="connected-body-body">
                                    {!photo.photoUrl && !isCameraOpen && (
                                        <>
                                        <button className="birth-button birth-special_button birth-button-open_camera" type="button" onClick={openCamera}>
                                            Prendre une photo
                                        </button>
                                        </>
                                    )}

                                    {isCameraOpen && !photo.photoUrl && (
                                        <>
                                        <div className="birth-camera">
                                            <video 
                                                ref={videoRef}
                                                className="birth-camera-video"
                                                autoPlay
                                                playsInline
                                                muted
                                            />

                                            <canvas
                                                ref={canvasRef}
                                                style={{ display: "none" }}
                                            />

                                            <div className="birth-camera-actions">
                                                <button
                                                    type="button"
                                                    className="birth-button birth-special_button birth-camera-cancel"
                                                    onClick={stopCamera}
                                                >
                                                    Annuler
                                                </button>

                                                <button
                                                    type="button"
                                                    className="birth-button birth-special_button birth-camera-turncamera"
                                                    onClick={switchCamera}
                                                >
                                                    Retourner la caméra
                                                </button>

                                                <button
                                                    type="button"
                                                    className="birth-button birth-special_button birth-camera-take"
                                                    onClick={(e) => {
                                                        e.preventDefault()
                                                        takePhoto()
                                                    }}
                                                >
                                                    Prendre la photo
                                                </button>
                                            </div>
                                        </div>
                                        </>
                                    )}

                                    {photo.photoUrl && (
                                        <>
                                        <div className="birth-photo-preview">
                                            <img
                                                src={photo.photoUrl}
                                                alt="Photo prise"
                                                className="birth-photo-preview-image"
                                            />

                                            <div className="birth-photo-preview-actions">
                                                <button
                                                    type="button"
                                                    onClick={retakePhoto}
                                                    className="birth-button birth-special_button birth-button-retake_photo"
                                                >
                                                    Reprendre
                                                </button>
                                            </div>
                                        </div>
                                        </>
                                    )}
                                </div>

                                <div className="connected-body-footer">

                                </div>
                            </div>

                            <div className="connected-footer">
                                <div className="birth-inputbo birth-inputbo-sendmessagex">
                                    <textarea 
                                        name="message"
                                        className="birth-input birth-input-sendmessage"
                                        placeholder="Écrire un message"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        required
                                    />

                                    <button className="birth-button birth-special_button birth-button-sendmsg" onClick={(e) => {
                                        if(photo.photoUrl) {
                                            handleSendPhoto(e)
                                        } else {
                                            handleSendMessage(e)
                                        }
                                    }}>
                                        Envoyer !
                                    </button>
                                </div>
                            </div>
                        </div>
                        </>
                    ) : (
                        <>
                        <div className="photobooth-interface">
                            <div className={`photobooth-camera photobooth-camera-${photoboothMontage.photoUrl ? "hidden" : "visible"}`}>
                                {photoboothTimer < 4 && (
                                    <>
                                    <span className="photobooth-timer">
                                        {photoboothTimer}
                                    </span>
                                    </>
                                )}

                                {photoboothTimer === 1 && (
                                    <div className="photo-effect" />
                                )}

                                <video 
                                    ref={videoRef}
                                    className="birth-photobooth-video"
                                    autoPlay
                                    playsInline
                                    muted
                                />

                                <canvas
                                    ref={canvasRef}
                                    style={{ display: "none" }}
                                />

                                {photoboothTimer >= 4 && (
                                    <>
                                    <div className="photobooth-actions">
                                        <button className="photobooth-button" onClick={startPhotobooth}>
                                            C'est parti !
                                        </button>
                                    </div>
                                    </>
                                )}
                            </div>

                            <div className="photobooth-result">
                                {photoboothMontage.photoUrl && (
                                    <>
                                    <img 
                                        src={photoboothMontage.photoUrl}
                                        className="photobooth-result-img"
                                    />
                                    </>
                                )}
                            </div>
                        </div>
                        </>
                    )}
                    </>
                )}
            </div>
        </div>
    )
}

export default BirthdayJoin